import { render, staticRenderFns } from "./promptDeposited.vue?vue&type=template&id=36e63454&scoped=true"
import script from "./promptDeposited.vue?vue&type=script&lang=js"
export * from "./promptDeposited.vue?vue&type=script&lang=js"
import style0 from "./promptDeposited.vue?vue&type=style&index=0&id=36e63454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e63454",
  null
  
)

export default component.exports